export { default } from "./speciesCard";
